import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgToon = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M30.44 10H9.56A4.56 4.56 0 0 0 5 14.56v10.88A4.56 4.56 0 0 0 9.56 30h20.88A4.56 4.56 0 0 0 35 25.44V14.56A4.56 4.56 0 0 0 30.44 10"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M33.5 26.44V21h1v5.44a5.06 5.06 0 0 1-5.06 5.06H17v-1h12.44a4.06 4.06 0 0 0 4.06-4.06"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="M31.4 13H8.6a.6.6 0 0 0-.6.6v12.8a.6.6 0 0 0 .6.6h22.8a.6.6 0 0 0 .6-.6V13.6a.6.6 0 0 0-.6-.6"
    />
    <path
      fill="#ECF9EC"
      d="M15.91 15H10v5h5.91zM15.91 21H10v4h5.91zM23 15h-5.91v5H23zM30 15h-5.91v10H30zM23 21h-5.91v4H23z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgToon);

export default ForwardRef;
